// Optimized font loading strategy

// Optimize your waitForFonts utility:
export const waitForFonts = async () => {
  if (!('fonts' in document)) {
    return; // Fallback for older browsers
  }

  try {
    // Only wait for critical fonts, not all fonts
    const criticalFonts = ['Londrina Solid', 'Winky Sans'];

    await Promise.allSettled(
      criticalFonts.map((font) => document.fonts.load(`400 1em "${font}"`)),
    );
  } catch (error) {
    console.warn('Font loading failed:', error);
    // Continue anyway - don't block the app
  }
};
